import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eventbrite/i18n';
import { LoadingOverlay } from '@eb/eds-loading-overlay';
import SeriesEventDatePickerContainer from './SeriesEventCalendarContainer';
import SeriesEventCardListContainer from './SeriesEventCardListContainer';
import LanguageAndBrandContainer from '../LanguageAndBrandContainer';
import PageTemplateContainer from '../template/PageTemplateContainer';
import './seriesPage.scss';

export class SeriesPage extends React.PureComponent {
    static propTypes = {
        isLoading: PropTypes.bool,
        onPageMounted: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            isPaneOpen: false,
        };
    }

    componentDidMount() {
        const { onPageMounted } = this.props;

        onPageMounted();
    }

    _onPaneToggle() {
        this.setState(({ isPaneOpen }) => ({ isPaneOpen: !isPaneOpen }));
    }

    render() {
        const { isLoading } = this.props;
        const extraModalBodyProps = { shouldShowFooter: true };
        const extraPaneProps = { isSeriesParentPage: true };
        const eventDates = gettext('Multiple Dates');
        const { isPaneOpen } = this.state;

        return (
            <PageTemplateContainer
                containerClassName="eds-align--center-horizontal eds-l-mar-bot-3"
                extraModalBodyProps={extraModalBodyProps}
                extraPaneProps={extraPaneProps}
                handleSubmit={null}
                isPaneOpen={isPaneOpen}
                isSubmitDisabled={true}
                secondaryTitle={eventDates}
                onPaneToggle={this._onPaneToggle.bind(this)}
                tertiaryNode={<LanguageAndBrandContainer isSeriesPage={true} />}
            >
                <SeriesEventDatePickerContainer />

                <div
                    className="series-events-container"
                    data-automation="series-events-container"
                >
                    <SeriesEventCardListContainer />
                </div>

                <LoadingOverlay size="large-thin" isShown={isLoading} />
            </PageTemplateContainer>
        );
    }
}
